/**
 * Converts a string to Title Case (first letter of each word capitalized)
 * @param {string} str - The string to convert
 * @returns {string} The title-cased string
 */
export function toTitleCase(str) {
  if (!str) return str;
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
